import { createFileRoute } from "@tanstack/react-router";
import { LogTranscriptPage } from "@/components/admin/ai-assistant/log-transcript-page";

export const Route = createFileRoute(
	"/admin/ai-assistant/log/$userId/$conversationId",
)({
	component: LogTranscriptPage,
});
